namespace advisorop.components.servicer{

    
    export class TampListController {
        dg: DevExpress.ui.dxDataGridOptions;
        tamp: domains.ITamp;
        tamps: domains.ITamp[];
        tampTypes: domains.ILOV[] = [];
        selTampType: domains.ILOV;
        showTampPanel: boolean = false;
        tampTypesLoaded: boolean = false;

        static $inject = ["servicerService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService) {
            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Tamps"
                },
                bindingOptions: {
                    dataSource: "vm.tamps",
                    "columns[1].lookup.dataSource": "vm.tampTypes"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no tamps",
                allowColumnResizing: false,            
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "name", caption: "Tamp Name", cellTemplate: "colFullName", sortIndex: 0, sortOrder: "asc" },
                    {
                        dataField: "type", caption: "Type",
                        lookup: {
                            dataSource: this.tampTypes,
                            valueExpr: "value", displayExpr: "name"
                        }
                    },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width:"100" }
                ],

            };
        }


        newTamp(): void {
            this.tamp = {};
            this.showTampPanel = true;
        };

        tampTypeChanged(): void {
            this.tamp.type = this.selTampType.value;
        }

        addTamp(): void {

            if (!this.selTampType) {
                toastr.warning("Please select type of tamp.");
                return;
            }

            this.tamp.type = this.selTampType.value;

            this.servicerService.createTamp(this.tamp)
                .then((response) => {
                    toastr.success("Tamp successfully added.");
                    this.tamps.push(response.data);
                    this.cleanInputs();
                }).
                catch(err => {
                    toastr.error("Cannot add tamp!");
                });
        };

        cleanInputs(): void {
            this.tamp = {};
            this.selTampType = null;
            this.showTampPanel = false;
        }

        editTamp(tampId: number): void {
            this.servicerService.getTampsById(tampId)
                .then(response => {
                    this.tamp = response.data;
                    this.selTampType = this.tampTypes.filter(v => { return v.value == this.tamp.type; })[0];
                    this.showTampPanel = true;
                }, err => toastr.error("Cannot fetch tamp") );
        }

        updateTamp(): void {

            this.tamp.type = this.selTampType.value;
            this.servicerService.updateTamp(this.tamp).
                then(response => {
                    toastr.success("Tamp successfully updated.");
                    this.loadTamps();
                    this.cleanInputs();
                }).
                catch(err => {
                    toastr.error("Unable to update tamp.");
                });
        };
        
        deleteTamp(tamp: domains.ITamp): void {

            var x = this.tamps;

            if (!window.confirm("Are you sure ?"))
                return;

            this.servicerService.deleteTamp(tamp.id).
                then((response) => {

                    toastr.success("Tamp deleted.");

                    var ind = x.indexOf(tamp);
                    if (ind >= 0) {
                        x.splice(ind, 1);
                    }
                    this.loadTamps();
                }).
                catch(err => {
                    toastr.error("Cannot delete this tamp!");
                });
        };

        loadTamps(): void {
            this.servicerService.getTamps().
                then((response) => {
                    this.tamps = response.data;
                    this.dg.dataSource = this.tamps;
                }).
                catch(err => {
                    toastr.error("Cannot fetch managers for this advisory firm!");
                });
        };

        loadLovs(): void {
            this.generalService.getLOVs()
                .then(data => {
                    this.tampTypes = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.TAMP_TYPE; });
                    this.tampTypesLoaded = true;
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {
            this.loadLovs();
            this.loadTamps();
        }
    }


    class TampList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = TampListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/tamp-list.html";
        }
    }
    angular.module(Constants.APP).component("tampList", new TampList());
}